import React from 'react';
import { Section, CtaButton } from './ui';
export const Closing = () => {
  return <Section className="bg-brand-cream" data-id="element-45">
      <div className="text-center" data-id="element-46">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-serif font-semibold mb-8 leading-tight" data-id="element-47">
          Última pregunta — la más importante
        </h2>

        <div className="bg-blue-50 border border-blue-100 rounded-3xl p-6 md:p-12 max-w-3xl mx-auto shadow-soft mb-10 text-left" data-id="element-48">
          <h3 className="text-xl sm:text-2xl md:text-3xl font-serif font-semibold text-blue-900 mb-6 text-center leading-snug" data-id="element-49">
            ❓ “¿Y si esta vez sí funciona?”
          </h3>

          <div className="space-y-5 text-base sm:text-lg md:text-xl text-blue-800 font-medium" data-id="element-50">
            <div className="flex items-start gap-3" data-id="element-51">
              <span className="text-brand-green text-2xl mt-0.5 shrink-0" data-id="element-52">
                ✅
              </span>
              <p data-id="element-53">Imagina cortar el pastel y que no se desmorone.</p>
            </div>
            <div className="flex items-start gap-3" data-id="element-54">
              <span className="text-brand-green text-2xl mt-0.5 shrink-0" data-id="element-55">
                ✅
              </span>
              <p data-id="element-56">Imagina ver a otros repetir sin preguntar qué tiene.</p>
            </div>
            <div className="flex items-start gap-3" data-id="element-57">
              <span className="text-brand-green text-2xl mt-0.5 shrink-0" data-id="element-58">
                ✅
              </span>
              <p data-id="element-59">
                Imagina volver a disfrutar el postre sin culpa ni frustración.
              </p>
            </div>
          </div>
        </div>

        <div className="max-w-2xl mx-auto text-center" data-id="element-60">
          <p className="text-xl sm:text-2xl font-bold text-brand-red mb-5" data-id="element-61">
            👉 Haz clic ahora
          </p>

          <h3 className="text-3xl sm:text-4xl md:text-5xl font-serif font-semibold mb-2 leading-tight" data-id="element-62">
            Descarga “Pasteles Sin Culpa”
          </h3>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 mb-8" data-id="element-63">
            Aplica el Método de Estructura Húmeda™ hoy mismo
          </p>

          <CtaButton className="w-full md:w-auto mb-4" data-id="element-64" />

          <p className="text-base sm:text-lg font-bold text-gray-500" data-id="element-65">
            Acceso inmediato por solo $9.990 ARS
          </p>
        </div>
      </div>
    </Section>;
};